(() => {
  'use strict';

  const FRAME_SELECTOR = [
    '.pc-media',
    '.tc-media',
    '.shop-card__visual',
    '.flow-card__media',
    '.product-main-media',
    '.product-page__media',
    '.product-gallery__stage',
    '.md-product-gallery__image',
    '.vp-stage',
    '.collection-card__image',
    '.collection-card__media',
    '.md-collection-card__media',
    '.recommend-card__media',
    '.related-card__media',
    '.v-card__media',
    '.dusk-cart-item__image',
    '.cart-line__image',
    '.cart-line-item__media',
    '.md-cart-line__image',
    '.vc-cart-media',
    '.product-thumbnail',
    '.product-gallery__thumb',
    '.product-media-thumb',
    '.vp-thumb'
  ].join(',');

  const WHITE_PACKSHOT_WORDS = /(?:\bclean\s*white\b|\bwhite\s*(?:background|backdrop|studio)\b|\bpackshot\b|\bproduct\s*only\b|\bfront\s*view\b|\bback\s*view\b)/i;
  const FORCE_CONTAIN = /\[(?:fit:)?contain\]/i;
  const FORCE_COVER = /\[(?:fit:)?cover\]/i;

  const resolveFit = (img) => {
    if (!(img instanceof HTMLImageElement)) return;
    const alt = img.getAttribute('alt') || '';
    let fit = 'cover';

    if (FORCE_COVER.test(alt)) {
      fit = 'cover';
    } else if (FORCE_CONTAIN.test(alt) || WHITE_PACKSHOT_WORDS.test(alt)) {
      fit = 'contain';
    } else if (img.naturalWidth && img.naturalHeight) {
      const ratio = img.naturalWidth / img.naturalHeight;
      fit = ratio < 0.86 ? 'contain' : 'cover';
    }

    img.dataset.pmV6Fit = fit;
  };

  const prepareFrame = (frame) => {
    if (!(frame instanceof Element)) return;
    const images = frame.querySelectorAll('img');
    if (!images.length) return;
    frame.classList.add('has-product-media-v6');
    images.forEach((img) => {
      img.dataset.productMediaV6 = '';
      if (img.complete) resolveFit(img);
      else img.addEventListener('load', () => resolveFit(img), { once: true });
    });
  };

  const prepare = (root = document) => {
    if (!root || typeof root.querySelectorAll !== 'function') return;
    root.querySelectorAll(FRAME_SELECTOR).forEach(prepareFrame);
    root.querySelectorAll('.cart-page-line > img').forEach((img) => {
      img.dataset.productMediaV6 = '';
      if (img.complete) resolveFit(img);
      else img.addEventListener('load', () => resolveFit(img), { once: true });
    });
  };

  const start = () => {
    prepare(document);

    const observer = new MutationObserver((records) => {
      records.forEach((record) => {
        if (record.type === 'attributes' && record.target instanceof HTMLImageElement) {
          resolveFit(record.target);
          return;
        }
        record.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) return;
          if (node.matches?.(FRAME_SELECTOR)) prepareFrame(node);
          prepare(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'alt']
    });

    document.addEventListener('shopify:section:load', (event) => prepare(event.target));
    document.addEventListener('shopify:section:reorder', () => prepare(document));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
